<template>
    <LoginLayout>

        <div class="mb-0 LoginCard">
            <!-- Panel logowania -->
            <div class="card-body">
                <LoginForm :email="email" />

                <hr>

                <ExternalLogins/>
            </div>
        </div>
    </LoginLayout>
</template>

<script>

    import store from '../../store';
    import LoginLayout from "./../layouts/LoginLayout";
    import LoginForm from "../../components/Auth/LoginForm";
    import {mapGetters, mapState} from "vuex";
    import {grantAccessToContextApp} from "@/services/AuthService";
    import ExternalLogins from "@/modules/Auth/components/ExternalLogins.vue";

    const beforeRouteEnterAction = async (to, from, next) => {
        await store.dispatch('Auth/resetState')

        next(vm => {
            if (to.query.email) {
                vm.email = to.query.email
            }
        });
    };

    export default {
        name: 'LoginView',

        components: {
            LoginForm,
            LoginLayout,
            ExternalLogins
        },

        data: () => ({
            email: '',
            password: ''
        }),

        computed: {
            ...mapState('Auth', ['isLoading', 'hasError', 'error']),
            ...mapGetters('Auth', ['hasAccessToContextApp']),
            ...mapState(['context']),

            isAuthenticated() {
                return this.$store.state.Auth.isAuthenticated;
            }
        },

        beforeRouteEnter: beforeRouteEnterAction,
        beforeRouteUpdate: beforeRouteEnterAction,

        watch: {
            isAuthenticated: {
                immediate: true,
                async handler(authenticated){
                    // Jeśli nie jest zalogowany to nic nie robimy
                    if (! authenticated) {
                        return;
                    }
                    // Jeśli jest kontekst, to sprawdzamy czy użytkownik ma dostęp
                    if (this.context.app) {
                        this.$store.dispatch('Auth/fetchApplications')
                            .then(() => {
                                grantAccessToContextApp(this.$router, () => this.$router.push({name: 'Dashboard'}));
                            })
                            .catch(() => this.$router.push({name: 'Dashboard'}))
                    } else {
                        this.$router.push({name: 'Dashboard'});
                    }
                }
            }
        }
    }
</script>
